<template>
  <div>
    <el-form :model="queryParams"
             ref="queryForm"
             size="small"
             :inline="true">
      <el-form-item label="标题"
                    prop="title">
        <el-input v-model="queryParams.title"
                  placeholder="请输入标题"
                  clearable
                  @keyup.enter.native="handleQuery" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary"
                   icon="el-icon-search"
                   size="mini"
                   @click="handleQuery">搜索</el-button>
      </el-form-item>
    </el-form>
    <el-row :gutter="10"
            class="mb8">
      <el-col :span="1.5">
        <el-button type="primary"
                   plain
                   icon="el-icon-plus"
                   size="mini"
                   @click="handleAdd(true)">新增</el-button>
      </el-col>
      <!-- // 批量删除1 -->
      <el-col :span="1.5">
        <el-button type="danger"
                   plain
                   icon="el-icon-delete"
                   size="mini"
                   @click="handleDeleteAll">删除</el-button>
      </el-col>
    </el-row>
    <el-table v-loading="loading"
              :data="noticeList"
              @selection-change="handleSelectionChange">
      <el-table-column type="selection"
                       width="55"
                       align="center" />
      <el-table-column label="标题"
                       prop="Title" :show-overflow-tooltip="true" />
      <el-table-column label="适用App"
                       prop="AppIds"
                       :show-overflow-tooltip="true" />
      <el-table-column label="操作"
                       prop="Href"
                       :show-overflow-tooltip="true" />
      <el-table-column label="分类"
                       prop="Category"
                       :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{scope.row.Category==1?'tips':'说明'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态"
                       prop="State"
                       :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{scope.row.State==1?'正常':'下架'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作"
                       width="280"
                       align="center"
                       class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button size="mini"
                     type="text"
                     icon="el-icon-tickets"
                     @click="handleDetail(scope.row)">详情</el-button>
          <el-button size="mini"
                     type="text"
                     icon="el-icon-edit"
                     @click="handleUpdate(scope.row)">编辑</el-button>
          <el-button size="mini"
                     type="text"
                     icon="el-icon-delete"
                     @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-show="total>0"
                   :total="total"
                   :page-sizes="[2, 5, 10, 15]"
                   layout="total, sizes, prev, pager, next, jumper"
                   :page.sync="queryParams.pageNum"
                   :limit.sync="queryParams.pageSize"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :current-page.sync="currentPage1" />
    <!-- 详情 -->
    <el-dialog title="详情"
               class="openDialog"
               :visible.sync="openDetail"
               width="650px"
               append-to-body>
      <el-form class="detail"
               ref="form"
               :model="form"
               label-width="100px">
        <el-col :span="12">
          <el-form-item label="标题"
                        prop="RoleName">
            {{form.Title}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="适用App">
            {{form.AppIds}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="操作"
                        prop="RoleName">
            {{form.Href}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="分类">
            {{form.Category==1?'tips':'说明'}}
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="状态">
            {{form.State==0?'未确认':(form.State==1?'已确认':'')}}
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注">
            {{form.Remark}}
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="内容">
            <div v-html="form.Content"></div>
          </el-form-item>
        </el-col>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="cancelDetail">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listNotice, deleteNotice, detailNotice } from '@/api/notice'
export default {
  // name:'notice',
  data () {
    return {
      currentPage1: 1,
      queryParams: {},
      noticeList: [],
      multipleSelection: [],
      total: 0,
      loading: false,
      form: {},
      openDetail: false
    }
  },
  mounted () {
    this.handleQuery()
  },
  methods: {
    cancelDetail () {
      this.openDetail = false;
    },
    handleSizeChange (val) {
      this.queryParams.pageSize = val
      this.getList2()
    },
    handleCurrentChange (val) {
      this.queryParams.pageNum = val
      this.getList2()
    },
    // 详情
    async handleDetail (row) {
      this.openDetail = true
      const [res, err] = await detailNotice(row.Id)
      let rowData = res.data.Data
      this.form = { ...rowData }
    },
    async handleQuery () {
      const [res, err] = await listNotice({ title: this.queryParams.title, pageSize: this.queryParams.pageSize, pageIndex: this.queryParams.pageIndex })

      this.noticeList = res.data.Data
      this.total = res.data.TotalCount

    },
    handleAdd () {
      this.$router.push('/sys/noticeForm')
    },
    async handleUpdate (row) {

      this.$router.push({ path: '/sys/noticeForm', query: row })
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      this.$confirm('此操作将永久删除该角色, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const [res, err] = await deleteNotice(String(row.Id))

        this.getList()
      })
    },
    // 批量删除1
    handleSelectionChange (val) {
      this.multipleSelection = val.map((item) => item.Id);
    },
    // 批量删除1
    handleDeleteAll () {
      var obj = this.multipleSelection
      if (obj.length == 0) {
        this.$message.error('请选择数据')
        return
      }
      this.$confirm('此操作将永久删除选中的用户信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        var obj = this.multipleSelection
        // 批量删除1
        const [res, err] = await deleteNotice(obj)

        this.handleQuery()

      })
    },
  }
}
</script>

<style scoped>
.detail {
  height: 200px;
}
</style>